// Order of the case studies, used for the "Next case study" link at the bottom of each page.
// Add a new case study here and give it a route in App.jsx.
export const CASE_STUDIES = [
  { slug: "aplivia", title: "Aplivia", summary: "AI job application assistant" },
  { slug: "crmbuzz", title: "CRMBuzz", summary: "White-label CRM & website builder" },
  { slug: "bpmflow", title: "BPMFlow", summary: "Business process management platform" },
  { slug: "immoflow", title: "ImmoFlow", summary: "Real estate agency management platform" },
  { slug: "codequery", title: "CodeQuery", summary: "AI-powered Q&A platform" },
];

export const nextCaseStudy = (slug) => {
  const index = CASE_STUDIES.findIndex((c) => c.slug === slug);
  if (index === -1 || CASE_STUDIES.length < 2) return null;
  return CASE_STUDIES[(index + 1) % CASE_STUDIES.length];
};
